import request from '@/utils/infrastructure/communication/request';

export async function queryUserGroupUsers(payload) {
  return request(`/userGroup/users/${payload.userGroupId}`, {
    params: payload.params,
  });
}

export async function queryAddUserGroupUser(payload) {
  return request.post(`/userGroupUser/updateUsers/${payload.id}`, {
    data: payload.data,
  });
}
